export const db_DDIs = [
  {
    categoryKey: "ddi.category.analgesicos",
    medications: [
      {
        nameKey: "medication.acidoAcetilsalicilico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.alfentanilo",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.buprenorfina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.celecoxib",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.codeina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.dextropropoxifeno",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.diacetilmorfinaDiamorfina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.diclofenac",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.diHidrocodeina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fentanilo",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.hidrocodona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.hidromorfona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ibuprofeno",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.acidoMefenamico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metamizol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.metadona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.morfina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.naproxeno",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.nimesulida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.oxicodona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.paracetamol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.petidinaMeperidina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.piroxicam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tramadol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.diflunisal",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antiarritmicos",
    medications: [
      {
        nameKey: "medication.amiodarona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.bepridilo",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.disopiramida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.flecainida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.lidocaina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.mexiletina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.propafenona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.quinidina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antibacterianos",
    medications: [
      {
        nameKey: "medication.amicacina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.amoxicilina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ampicilina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.azitromicina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.bedaquilina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.capreomicina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cefalexina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.cefazolina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cefixima",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cefotaxima",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ceftazidima",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ceftriaxona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cloranfenicol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.ciprofloxacina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.claritromicina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoClavulanico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clindamicina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.clofazimina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.cloxacilina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cicloserina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dapsona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.doxiciclina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ertapenem",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.eritromicina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.etambutol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.etionamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.flucloxacilina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.gentamicina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.imipenemcilastatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.isoniazida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.canamicina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.levofloxacina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.linezolida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.meropenem",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metronidazol",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.moxifloxacina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nitrofurantoina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ofloxacina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoParaAminossalicilico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.penicilinas",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pirazinamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.rifabutina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.rifampicina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.rifapentina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.rifaximina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.espectinomicina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.estreptomicina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sulfadiazina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tazobactam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.telitromicina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tetraciclina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.trimetoprimsulfametoxazol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.vancomicina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.avibactamaztreonam",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.ertapenemSodico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.polihexanida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey:
      "ddi.category.anticoagulantesAntiagregantesPlaquetariosEFibrinoliticos",
    medications: [
      {
        nameKey: "medication.acenocumarol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.apixabano",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.clopidogrel",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dabigatrano",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.dalteparina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dipiridamol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.edoxabano",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.eltrombopag",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.enoxaparina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fondaparinux",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.heparina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.nadroparina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.femprocumona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.prasugrel",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.rivaroxabano",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.estreptoquinase",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ticagrelor",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.tinzaparina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.varfarina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.dabigatran",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.garadacimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.marstacimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sebetralstat",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.anticonvulsivantes",
    medications: [
      {
        nameKey: "medication.carbamazepina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fosfenitoina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.gabapentina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.oxcarbazepina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fenobarbitalFenobarbitona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fenitoina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.pregabalina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.acidoValproicoValproato",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.amifampridinaFosfato",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.ganaxolona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.lacosamida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antidepressivos",
    medications: [
      {
        nameKey: "medication.agomelatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.amitriptilina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.bupropiom",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.citalopram",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.clomipramina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.desipramina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.doxepina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.duloxetina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.escitalopram",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fluoxetina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fluvoxamina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.imipramina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.litio",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.maprotilina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.mianserina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.milnaciprano",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.mirtazapina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.nefazodona",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nortriptilina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.paroxetina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fenelzina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.reboxetina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.sertralina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.tranilcipromina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.trazodona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.trimipramina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.venlafaxina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antidiabeticos",
    medications: [
      {
        nameKey: "medication.acarbose",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dulaglutido",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.exenatido",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.glibenclamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.gliclazida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.glimepirida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.glipizida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.insulina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.linagliptina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.liraglutido",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metformina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.nateglinida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pioglitazona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.repaglinida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.rosiglitazona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.saxagliptina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.sitagliptina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.tolbutamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.vildagliptina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.dapagliflozin",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.insulinaAspartico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.insulinaIcodec",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sitagliptinacloridratoDeMetformina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.sitagliptin",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.tirzepatida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antifungicos",
    medications: [
      {
        nameKey: "medication.anfotericinaB",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.anidulafungina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.caspofungina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fluconazol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.flucitosina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.griseofulvina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.itraconazol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.cetoconazol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.miconazol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nistatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.posaconazol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.terbinafina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.voriconazol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.rezafungina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antiHistaminicos",
    medications: [
      {
        nameKey: "medication.astemizol",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.cetirizina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clorofenamina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clemastina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.difenidramina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fexofenadina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.levocetirizina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.loratadina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.prometazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antipsicoticosNeurolepticos",
    medications: [
      {
        nameKey: "medication.amissulprida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.aripiprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.asenapina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cloropromazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.clozapina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.flufenazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.haloperidol",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.iloperidona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.levomepromazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.olanzapina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.paliperidona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.perazina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.periciazina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.perfenazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.pimozida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.pipotiazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.quetiapina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.risperidona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sertindol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sulpirida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tioridazina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tiaprida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.ziprasidona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.zotepina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.zuclopentixol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.ansioliticosHipnoticosSedativos",
    medications: [
      {
        nameKey: "medication.alprazolam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.bromazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.buspirona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.clorodiazepoxido",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.clorazepato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.diazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.estazolam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.flunitrazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.flurazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.hidroxizina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.lorazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lormetazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.midazolamOral",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.midazolamParenterico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.oxazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.temazepam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.triazolam",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.zaleplom",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.zolpidem",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.zopiclona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.daridorexant",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.bloqueadoresBeta",
    medications: [
      {
        nameKey: "medication.atenolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.bisoprolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.carvedilol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metoprolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nebivolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.oxprenolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pindolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.propranolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sotalol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.timolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.bifosfonatos",
    medications: [
      {
        nameKey: "medication.acidoAlendronico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoIbandronico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoPamidronico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoZoledronico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.broncodilatadores",
    medications: [
      {
        nameKey: "medication.formoterol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.brometoDeIpratropio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.montelucaste",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.salbutamol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.salmeterol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.teofilina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.indacaterolglicopirronioFuroatoDeMometasona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.bloqueadoresDosCanaisDeCalcio",
    medications: [
      {
        nameKey: "medication.amlodipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.diltiazem",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.felodipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nicardipina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nifedipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nisoldipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nitrendipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.verapamilo",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.contracetivosTerapeuticaHormonalDeSubstituicao",
    medications: [
      {
        nameKey: "medication.desogestrel",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.drospirenona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.didrogesterona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.estradiol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.etinilestradiol",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.etonogestrel",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.gestodeno",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.levonorgestrel",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.levonorgestrelContracecaoDeEmergencia",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey:
          "medication.medroxiprogesteronaInjetavelDeLibertacaoProlongada",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.medroxiprogesteronaOutrasFormulacoes",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.norelgestromina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.noretisteronaNoretindrona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.norgestimato",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.norgestrel",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.ulipristal",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fezolinetant",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.agentesGastrointestinais",
    medications: [
      {
        nameKey: "medication.alosetron",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.hidroxidoDeAluminio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.antiacidos",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.bisacodilo",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cimetidina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.cisaprida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.esomeprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.famotidina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lactulose",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lansoprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.loperamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.mesalazina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.omeprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pantoprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.prucaloprida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.rabeprazol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ranitidina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sene",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.citratoFerrico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.maralixibat",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.octreotida",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.odevixibat",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.fumaratoDeTegomil",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.agentesGastrointestinaisAntiemeticos",
    medications: [
      {
        nameKey: "medication.aprepitant",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.dolasetron",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.domperidona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.dronabinol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.fosaprepitant",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.granissetrom",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.metoclopramida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ondansetrom",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.palonossetrom",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.proclorperazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tropissetrom",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.plantasMedicinaisSuplementosVitaminas",
    medications: [
      {
        nameKey: "medication.sumoDeToranja",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.chaVerde",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.suplementosDeFerro",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.nicotinamidaNiacinamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fitomenadionaVitaminaK",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.piridoxinaVitaminaB6",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.retinolVitaminaA",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.riboflavinaVitaminaB2",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ervaDeSaoJoaoHipericao",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tiaminaVitaminaB1",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.vitaminaE",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.agentesParaAHipertensaoInsuficienciaCardiaca",
    medications: [
      {
        nameKey: "medication.aliscireno",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.ambrisentano",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.amilorida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.bendroflumetiazida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.bosentano",
        interactions: {
          abemaciclib: 2,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.candesartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.captopril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clorotalidona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.cilazapril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clonidina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.digoxina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.dopamina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.doxazosina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.enalapril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.eprosartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.furosemida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.hidralazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.hidroclorotiazida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.indapamida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.irbesartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dinitratoDeIsossorbida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.ivabradina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.labetalol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lacidipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.lercanidipina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.lisinopril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.losartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.macitentano",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.metildopa",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metolazona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.olmesartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.perindopril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.prazosina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.quinapril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ramipril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ranolazina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sildenafilHipertensaoArterialPulmonar",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nitroprussiatoDeSodio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.espironolactona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tadalafilHipertensaoArterialPulmonar",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.telmisartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.torasemida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.trandolapril",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.valsartan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.xipamida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.enalaprilMaleato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.macitentanotadalafil",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.mavacamten",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sotatercept",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sparsentano",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.espironolactona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.vadadustat",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.imunomoduladores",
    medications: [
      {
        nameKey: "medication.hidroxiureiaHidroxicarbamida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.interferaoAlfa",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.interleucina2Aldesleucina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.peginterferaoAlfa2a",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.apremilast",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.delgocitinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.deucravacitinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.fumaratoDeDimetilo",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.etrasimod",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.lebrikizumab",
        interactions: {
          abemaciclib: 1,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.natalizumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.nemolizumab",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.nirsevimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.omalizumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ritlecitinib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.rozanolixizumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sipavibart",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.spesolimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sutimlimab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.teriflunomida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.tezepelumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.talidomida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.tocilizumab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.vilobelimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.zilucoplan",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.imunossupressores",
    medications: [
      {
        nameKey: "medication.azatioprina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.ciclosporina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.everolimusImunossupressor",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.micofenolato",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sirolimus",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.tacrolimus",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sirolimus",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.voclosporina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.crovalimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antidislipidemicos",
    medications: [
      {
        nameKey: "medication.atorvastatina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 4,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.bezafibrato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.clofibrato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ezetimiba",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fenofibrato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.oleosDePeixe",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fluvastatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.gemfibrozil",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lovastatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.pitavastatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.pravastatina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.rosuvastatina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.sinvastatina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 4,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.resmetirom",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.outros",
    medications: [
      {
        nameKey: "medication.alfuzosina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.alopurinol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.calcio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.colquicina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.dutasterida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.finasterida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.levotiroxina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.vacinasVivas",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.magnesio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metilfenidato",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.potassio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tansulosina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.tolterodina",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.acidoTranexamico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.acoramidisCloridrato",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.brensocatib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.danicopan",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.dasatinib",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.dasiglucagon",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.elafibranor",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.elinzanetant",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.eplontersenSodico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.gefapixant",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.givinostatee",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.iptacopana",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.lonafarnib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.olezarsen",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pirtobrutinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.rituximab",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.tiossulfatoDeSodio",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.vutrisiranSodico",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.difelicefalina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.epinefrina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.deutivacaftortezacaftorvanzacaftor",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.tiratricol",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey:
          "medication.lAlaninalArgininaacidoLAsparticoLCisteinaacidoLGlutamicoglicinalHistidinalLisinalMetioninalFenilalaninalProlinalSerinataurinalTreoninalTriptofanolTirosina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pirfenidona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.vibegron",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.sugammadex",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.esteroides",
    medications: [
      {
        nameKey: "medication.beclometasona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.betametasona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.budesonida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.clobetasol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.dexametasona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.fludrocortisona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.fluticasona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.hidrocortisonaOral",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.hidrocortisonaTopica",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.acetatoDeMegestrol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.metilprednisolona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.mometasona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nandrolona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.prednisolona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.prednisona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.estanozolol",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.testosterona",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.triamcinolona",
        interactions: {
          abemaciclib: 0,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.abirateronaAcetatoniraparib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.budesonida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.degarelix",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.elacestrant",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.enzalutamida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.leuprorrelina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.relugolix",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.vamorolona",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.agenteDeDiagnosticoRadiofarmaco",
    medications: [
      {
        nameKey: "medication.flortaucipir18f",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.gozetotida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.piflufolastat18f",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antienxaquecoso",
    medications: [
      {
        nameKey: "medication.atogepant",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.rimegepant",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antineoplasicoOncologico",
    medications: [
      {
        nameKey: "medication.adagrasib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.asciminib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.axitinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.azacitidina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.belantamabMafodotina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.belzutifano",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.capivasertib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.capmatinib",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.cedazuridinadecitabina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.dabrafenib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.datopotamabDeruxtecano",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.elranatamab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.enfortumabVedotina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.erdafitinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.eribulina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.fruquintinib",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.futibatinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.glofitamab",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.inavolisib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.ivosidenib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.lazertinib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.linvoseltamab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.loncastuximabTesirina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.mirdametinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.momelotinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.mosunetuzumab",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nilotinib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.nirogacestate",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.nivolumabrelatlimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.odronextamab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.pemetrexedo",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.pomalidomida",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.quizartinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.repotrectinib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.retifanlimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ruxolitinib",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.serplulimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sorafenib",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.sugemalimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.talquetamab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.tebentafusp",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.teclistamab",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.teprotumumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tislelizumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.tisotumabVedotina",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.toripalimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.trabectedin",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.trametinib",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.trastuzumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.tremelimumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ublituximab",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.vimseltinibDiHidratado",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.vorasidenib",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.zanidatamab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.zolbetuximab",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.antivirico",
    medications: [
      {
        nameKey: "medication.cabotegravir",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.emtricitabinarilpivirinaTenofovirAlafenamida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 3,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.emtricitabinatenofovirAlafenamida",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.lenacapavirSodico",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.maribavir",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.nirmatrelvirritonavir",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.doencaRaraMetabolicaEnzimatica",
    medications: [
      {
        nameKey: "medication.miglustat",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.cipaglucosidaseAlfa",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.fosdenopterina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey: "medication.mitapivat",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.olipudaseAlfa",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pegunigalsidaseAlfa",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pegzilarginase",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey:
          "medication.desintegrinaEMetaloproteinaseComMotivosDeTrombospondinaRecombinante13radamts13",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sepiapterina",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.hematologico",
    medications: [
      {
        nameKey: "medication.filgrastim",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.pegfilgrastim",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.plerixafor",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.sargramostim",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.metabolismoOsseoOsteoporose",
    medications: [
      {
        nameKey: "medication.abaloparatida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.denosumab",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.palopegteriparatida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.teriparatida",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.neurologico",
    medications: [
      {
        nameKey: "medication.donanemab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.lecanemab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.omaveloxolona",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
      {
        nameKey: "medication.tofersen",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.guanfacina",
        interactions: {
          abemaciclib: 2,
          palbociclib: 2,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.oftalmologico",
    medications: [
      {
        nameKey: "medication.aflibercept",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.faricimab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.ranibizumab",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.terapiaCelularGenetica",
    medications: [
      {
        nameKey: "medication.exagamglogeneAutotemcel",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.obecabtageneAutoleucel",
        interactions: {
          abemaciclib: 1,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 2,
          },
        },
      },
      {
        nameKey: "medication.tabelecleucel",
        interactions: {
          abemaciclib: 4,
          palbociclib: 4,
          ribociclib: {
            400: 4,
            600: 4,
          },
        },
      },
      {
        nameKey: "medication.eladocageneExuparvovec",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey: "medication.valoctocogeneRoxaparvovec",
        interactions: {
          abemaciclib: 0,
          palbociclib: 2,
          ribociclib: {
            400: 2,
            600: 3,
          },
        },
      },
    ],
  },
  {
    categoryKey: "ddi.category.vacinaImunizacaoAtiva",
    medications: [
      {
        nameKey:
          "medication.antigeneosDerivadosDeMycobacteriumTuberculosisRdesat6Rcfp10",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey:
          "medication.vacinaPneumococicaPolissacaridaConjugada21valenteCadaDoseTem4GDos21SerotiposConjugadosComCrm197",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey:
          "medication.vacinaDeMrnaContraOVirusSincicialRespiratorioMrnaQueCodificaAGlicoproteinaFDoVsra",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey:
          "medication.vacinaContraOVirusSincicialRespiratorioVsrRecombinanteAdjuvadaAntigenioRsvpref31",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey:
          "medication.vacinaContraOVirusSincicialRespiratorioAntigenicoFDoSubGrupoAAntigenicoFSubGrupoB",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
      {
        nameKey:
          "medication.selvacovateinaProteinaRbdRecombinanteVacinaContraACovid19",
        interactions: {
          abemaciclib: 0,
          palbociclib: 0,
          ribociclib: {
            400: 0,
            600: 0,
          },
        },
      },
      {
        nameKey:
          "medication.antigeniosDeSuperficieDoVirusDaGripeHemaglutininaENeuraminidaseInativadosDe3EstirpesAvictoria48972022Ivr238acroatia10136rv2023X425abaustria13594172021Bvr26",
        interactions: {
          abemaciclib: 1,
          palbociclib: 1,
          ribociclib: {
            400: 1,
            600: 1,
          },
        },
      },
    ],
  },
];
